import script from "./projectfollowup.vue?vue&type=script&lang=ts&setup=true"
export * from "./projectfollowup.vue?vue&type=script&lang=ts&setup=true"

import "./projectfollowup.vue?vue&type=style&index=0&id=14da0408&lang=scss"

const __exports__ = script;

export default __exports__